<template>
  <div>
    <div v-if="approvers && approvers.length" class="pr-approval-summary">
      <div class="d-flex justify-content-between mb-3">
        <div class="font-weight-bold">Người duyệt</div>
        <div class="font-weight-bold">Bước duyệt</div>
      </div>

      <div
        v-for="(item, idx) in sortedApprovers"
        :key="
          item.id ||
          Number(item.step) + '-' + idx + '-' + (item.approverBy || '')
        "
        class="d-flex justify-content-between align-items-center mb-3"
      >
        <div class="d-flex align-items-center">
          <div class="pr-approval-avatar" :style="avatarStyle(item.status)">
            <span>{{
              getInitials(item.approverByName || item.approverBy)
            }}</span>
            <i
              v-if="item.status"
              :class="approvalStatusIcon(item.status)"
              class="pr-approval-status-icon"
              :style="{ color: approvalStatusColor(item.status) }"
            ></i>
          </div>
          <div class="ml-3">
            <div class="font-weight-bold" style="line-height: 1.2">
              {{ item.approverByName || item.approverBy || '' }}
            </div>
          </div>
        </div>

        <b-badge
          :variant="approverStatusVariant(item.status)"
          class="pr-approval-step-badge"
          style="cursor: pointer"
          @click="openModalForStep(item.step)"
        >
          {{ approverStatusName(item.status) }}
        </b-badge>
      </div>
    </div>

    <p v-else class="text-muted mb-0">Chưa gửi duyệt</p>

    <PurchaseRequestApprovalModal
      ref="approvalModal"
      :requestId="requestId"
      :approvers="approvers"
    />
  </div>
</template>

<script>
import PurchaseRequestApprovalModal from './PurchaseRequestApprovalModal.vue';
import { APPROVER_STATUS, APPROVER_STATUS_BADGE_VARIANT } from '@/utils/enum';
import { APPROVER_STATUS_NAME } from '@/utils/enum-name';

export default {
  name: 'PurchaseRequestApprovalSummary',
  components: { PurchaseRequestApprovalModal },
  props: {
    requestId: {
      type: [String, Number],
      default: null,
    },
    approvers: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    sortedApprovers() {
      return [...(this.approvers || [])].sort((a, b) => {
        const sa = Number(a.step);
        const sb = Number(b.step);
        if (sa !== sb) return sa - sb;
        return String(a.approverByName || a.approverBy || '').localeCompare(
          String(b.approverByName || b.approverBy || ''),
        );
      });
    },
  },
  methods: {
    openModalForStep(step) {
      if (this.$refs.approvalModal) {
        this.$refs.approvalModal.open({ step });
      }
    },
    getInitials(name) {
      const raw = String(name || '').trim();
      if (!raw) return '--';
      const parts = raw.split(/\s+/).filter(Boolean);
      return parts
        .slice(0, 2)
        .map((p) => p[0])
        .join('')
        .toUpperCase();
    },
    approverStatusVariant(val) {
      return APPROVER_STATUS_BADGE_VARIANT[val] || 'secondary';
    },
    approverStatusName(val) {
      return APPROVER_STATUS_NAME[val] || val;
    },
    approvalStatusIcon(status) {
      // Only to mimic the "check" style in the reference screenshot.
      const map = {
        [APPROVER_STATUS.APPROVED]: 'fas fa-check',
        [APPROVER_STATUS.PENDING]: 'fas fa-clock',
        [APPROVER_STATUS.REJECTED]: 'fas fa-times',
        [APPROVER_STATUS.REVERTED]: 'fas fa-undo',
      };
      return map[status] || 'fas fa-info';
    },
    approvalStatusColor(status) {
      const map = {
        [APPROVER_STATUS.APPROVED]: '#1BC5BD',
        [APPROVER_STATUS.PENDING]: '#36A3F7',
        [APPROVER_STATUS.REJECTED]: '#F64E60',
        [APPROVER_STATUS.REVERTED]: '#50A5F1',
      };
      return map[status] || '#6c757d';
    },
    avatarStyle(status) {
      const map = {
        [APPROVER_STATUS.APPROVED]: '#1BC5BD',
        [APPROVER_STATUS.PENDING]: '#36A3F7',
        [APPROVER_STATUS.REJECTED]: '#F64E60',
        [APPROVER_STATUS.REVERTED]: '#50A5F1',
      };
      return { backgroundColor: map[status] || '#6c757d' };
    },
  },
};
</script>

<style scoped>
.pr-approval-avatar {
  width: 25px;
  height: 25px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  font-weight: 800;
  position: relative;
}

.pr-approval-avatar span {
  user-select: none;
}

.pr-approval-status-icon {
  position: absolute;
  right: -4px;
  bottom: -4px;
  font-size: 10px;
  padding: 3px;
  border-radius: 50%;
  background: #ffffff;
}

.pr-approval-step-badge {
  padding: 6px 9px;
  font-size: 0.875rem;
  border-radius: 8px;
}
</style>

